import { render } from "./footerDark.vue?vue&type=template&id=6b89c404"
import script from "./footerDark.vue?vue&type=script&lang=js"
export * from "./footerDark.vue?vue&type=script&lang=js"

import "./footerDark.vue?vue&type=style&index=0&id=6b89c404&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__